"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import * as j from "react";
import B from "classnames";
import { useIsInverseVariant as E } from "./theme-variant-context.js";
import { applyCssVars as L, pxToRem as p } from "./utils/css.js";
import { getPrefixedDataAttributes as M } from "./utils/dom.js";
import { useTheme as a } from "./hooks.js";
import { vars as m } from "./skins/skin-contract.css-mistica.js";
import { text as O, withWordBreak as q, withoutWordBreak as F, truncate as G, truncateToOneLine as J, vars as x } from "./text.css-mistica.js";
const K = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700
}, Q = (e)=>e === !0 ? 1 : e || "initial", n = (param)=>{
    let { weight: e, color: i = m.colors.textPrimary, decoration: t, truncate: o, transform: h, wordBreak: c = !0, hyphens: u = "auto", as: z = "span", children: g, size: d, mobileSize: b = d, desktopSize: T = d, lineHeight: k, mobileLineHeight: S = k, desktopLineHeight: f = k, letterSpacing: w, textAlign: H, textShadow: v, id: A, role: P, "aria-level": y, dataAttributes: W } = param;
    const I = E(), C = Q(o), V = {
        [m.colors.textPrimary]: m.colors.textPrimaryInverse,
        [m.colors.textSecondary]: m.colors.textSecondaryInverse,
        [m.colors.textLink]: m.colors.textLinkInverse
    };
    if (!g && g !== 0) return null;
    const D = B(O, c ? q : F, {
        [G]: o,
        [J]: o === 1 || o === !0
    }), N = L({
        [x.mobileSize]: b ? p(b) : "inherit",
        [x.mobileLineHeight]: S ? p(S) : "inherit",
        [x.desktopSize]: T ? p(T) : "inherit",
        [x.desktopLineHeight]: f ? p(f) : "inherit"
    }), R = o ? L({
        [x.lineClamp]: String(C)
    }) : {};
    var _V_i;
    return /*#__PURE__*/ j.createElement(z, _object_spread_props(_object_spread({
        className: D,
        id: A,
        role: P,
        "aria-level": y
    }, M(W, "Text")), {
        style: _object_spread_props(_object_spread({}, N, R), {
            hyphens: u,
            WebkitHyphens: u,
            letterSpacing: w,
            fontWeight: e ? K[e] : "inherit",
            textTransform: h || "inherit",
            textDecoration: t !== null && t !== void 0 ? t : "inherit",
            overflowWrap: c ? "anywhere" : "inherit",
            color: I ? (_V_i = V[i]) !== null && _V_i !== void 0 ? _V_i : i : i,
            textAlign: H,
            textShadow: v
        })
    }), g);
}, l = (e)=>{
    if (e.light) return "light";
    if (e.regular) return "regular";
    if (e.medium) return "medium";
    if (e.weight) return e.weight;
}, s = (param)=>{
    let { forceMobileSizes: e, mobileSize: i, mobileLineHeight: t, desktopSize: o, desktopLineHeight: h } = param;
    return e ? {
        size: i,
        lineHeight: t
    } : {
        mobileSize: i,
        mobileLineHeight: t,
        desktopSize: o,
        desktopLineHeight: h
    };
}, ie = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: o } = a();
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 48,
        mobileLineHeight: "56px",
        desktopSize: 64,
        desktopLineHeight: "72px"
    })), {
        weight: o.text10.weight,
        dataAttributes: _object_spread({
            "component-name": "Text10"
        }, e)
    }), t));
}, oe = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: o } = a();
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 40,
        mobileLineHeight: "48px",
        desktopSize: 56,
        desktopLineHeight: "64px"
    })), {
        weight: o.text9.weight,
        dataAttributes: _object_spread({
            "component-name": "Text9"
        }, e)
    }), t));
}, ne = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: o } = a();
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 32,
        mobileLineHeight: "40px",
        desktopSize: 48,
        desktopLineHeight: "56px"
    })), {
        weight: o.text8.weight,
        dataAttributes: _object_spread({
            "component-name": "Text8"
        }, e)
    }), t));
}, re = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: o } = a();
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 28,
        mobileLineHeight: "32px",
        desktopSize: 40,
        desktopLineHeight: "48px"
    })), {
        weight: o.text7.weight,
        dataAttributes: _object_spread({
            "component-name": "Text7"
        }, e)
    }), t));
}, se = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: o } = a();
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 24,
        mobileLineHeight: "32px",
        desktopSize: 32,
        desktopLineHeight: "40px"
    })), {
        weight: o.text6.weight,
        dataAttributes: _object_spread({
            "component-name": "Text6"
        }, e)
    }), t));
}, me = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    const { textPresets: o } = a();
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 20,
        mobileLineHeight: "24px",
        desktopSize: 28,
        desktopLineHeight: "32px"
    })), {
        weight: o.text5.weight,
        dataAttributes: _object_spread({
            "component-name": "Text5"
        }, e)
    }), t));
}, ae = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 18,
        mobileLineHeight: "24px",
        desktopSize: 20,
        desktopLineHeight: "28px"
    })), {
        weight: l(t),
        dataAttributes: _object_spread({
            "component-name": "Text4"
        }, e)
    }), t));
}, xe = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 16,
        mobileLineHeight: "24px",
        desktopSize: 18,
        desktopLineHeight: "24px"
    })), {
        weight: l(t),
        dataAttributes: _object_spread({
            "component-name": "Text3"
        }, e)
    }), t));
}, pe = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 14,
        mobileLineHeight: "20px",
        desktopSize: 16,
        desktopLineHeight: "24px"
    })), {
        weight: l(t),
        dataAttributes: _object_spread({
            "component-name": "Text2"
        }, e)
    }), t));
}, le = (_param)=>{
    var { dataAttributes: e, forceMobileSizes: i } = _param, t = _object_without_properties(_param, [
        "dataAttributes",
        "forceMobileSizes"
    ]);
    return /* @__PURE__ */ r(n, _object_spread(_object_spread_props(_object_spread({}, s({
        forceMobileSizes: i,
        mobileSize: 12,
        mobileLineHeight: "16px",
        desktopSize: 14,
        desktopLineHeight: "20px"
    })), {
        weight: l(t),
        dataAttributes: _object_spread({
            "component-name": "Text1"
        }, e)
    }), t));
}, he = n;
export { n as Text, le as Text1, ie as Text10, pe as Text2, xe as Text3, ae as Text4, me as Text5, se as Text6, re as Text7, ne as Text8, oe as Text9, he as default };
